import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <circle
        cx="128"
        cy="128"
        r="48"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M197.4 80.7a73.6 73.6 0 016.3 10.9l25.9 14.4a102 102 0 01.1 44l-26 14.4a73.6 73.6 0 01-6.3 10.9l.5 29.7a104 104 0 01-38.1 22.1l-25.5-15.3a88.3 88.3 0 01-12.6 0L96.3 227a102.6 102.6 0 01-38.2-22l.5-29.6a80.1 80.1 0 01-6.3-11L26.4 150a102 102 0 01-.1-44l26-14.4a73.6 73.6 0 016.3-10.9L58.1 51a104 104 0 0138.1-22.1l25.5 15.3a88.3 88.3 0 0112.6 0L159.7 29a102.6 102.6 0 0138.2 22z"
      />
    </svg>
  );
}

export default Icon;
